module.exports = __webpack_public_path__ + "img/yoav.816bfd0c.png";